import React from 'react'
import {useSelector} from 'react-redux'
import { Fragment} from 'react'
import RenderedHtmlContent from "../../../../shared/virtual_congress/components/rendered_html_content";

const Footer = () => {
  const footerText = useSelector(state => state.footerText).trim() // Not shared
  const formFooterText = useSelector(state => state.formFooterText).trim() // Shared between prefilled and registration

  return (
    <div className={"row"}>
      {formFooterText &&
        <div className="r-form-footer col-sm-12">
          <div className="r-form-footer-text">
            <RenderedHtmlContent html={formFooterText}/>
          </div>
        </div>
      }
      {footerText &&
        <div className="r-footer col-sm-12">
          <div className="r-footer-text">
            <RenderedHtmlContent html={footerText}/>
          </div>
        </div>
      }
    </div>
  )
}
export default Footer;
